import PropTypes from "prop-types"
import React from "react"
import TextChartODD13GHGEmissionsEmployeeMolecule from "views/molecules/canvases/charts/TextChartODD13GHGEmissionsEmployeeMolecule"
import TextChartODD13GHGEmissionsMolecule from "views/molecules/canvases/charts/TextChartODD13GHGEmissionsMolecule"
import ChartODD13GHGEmissionsDistributionConsolidateMolecule from "views/molecules/canvases/charts/ChartODD13GHGEmissionsDistributionConsolidateMolecule"
import ScoreLayoutOrganism from "views/organisms/scores/ScoreLayoutOrganism"
import TextChartODD13HighestITDomainEmissionsMolecule from "views/molecules/canvases/charts/TextChartODD13HighestITDomainEmissionsMolecule"
import ChartODD13GHGEmissionsInternalExternalMolecule from "views/molecules/canvases/charts/ChartODD13GHGEmissionsInternalExternalMolecule"
import ChartODD13ConsolidateChart3 from "views/molecules/canvases/charts/ChartODD13ConsolidateChart3"
import DonutChartTemplate from "views/molecules/charts/template/DonutChartTemplate"
import ChartODD13GhgPerVisitOrFallbackMolecule from "views/molecules/canvases/charts/ChartODD13GhgPerVisitOrFallbackMolecule"
import { useTranslation } from "react-i18next"

const BrandScoreLayoutOrganism = ({ score, trendBadges }) => {
  const { t } = useTranslation()

  const chart1TrendBadge = trendBadges?.odd13_CO2
  const chart2TrendBadge = trendBadges?.odd13_CO2_average_employee
  const maturityTrendBadge = trendBadges?.odd13_maturity

  return (
    <ScoreLayoutOrganism
      maturity={score.odd13_maturity ?? 0}
      maturityTrendBadge={maturityTrendBadge}
      chart1={
        <TextChartODD13GHGEmissionsMolecule
          score={score}
          ghgEmissions={score?.odd13_CO2}
          hidePercentage={!score?.should_diplay_percentage}
          trendBadge={chart1TrendBadge}
        />
      }
      chart2={
        <ChartODD13GhgPerVisitOrFallbackMolecule
          score={score}
          fallback={
            <TextChartODD13GHGEmissionsEmployeeMolecule
              score={score}
              trendBadge={chart2TrendBadge}
            />
          }
        />
      }
      chart3={
        <DonutChartTemplate
          title={t("score:score.13.chartEmissionBreakdownPerRegion.title")}
          data={score?.emissions_breakdown?.data}
          labelKeys={score?.emissions_breakdown?.labels}
          unitPath="units:units.emission"
          unitKey={score?.emissions_breakdown?.unit_key}
          helpText={t("score:score.13.chartEmissionBreakdownPerRegion.help")}
        />
      }
      chart4={
        <ChartODD13GHGEmissionsDistributionConsolidateMolecule
          score={score}
          translationScope={"brand"}
        />
      }
      chart5={<TextChartODD13HighestITDomainEmissionsMolecule score={score} />}
      chart6={
        score?.odd13_ghg_internal_external_spit ? (
          <ChartODD13GHGEmissionsInternalExternalMolecule
            ghgSplit={score?.odd13_ghg_internal_external_spit}
          />
        ) : (
          <ChartODD13ConsolidateChart3 score={score} />
        )
      }
    />
  )
}

BrandScoreLayoutOrganism.propTypes = {
  score: PropTypes.object.isRequired,
  trendBadges: PropTypes.object,
}

BrandScoreLayoutOrganism.defaultProps = {
  trendBadges: {},
}

export default BrandScoreLayoutOrganism